export const ACCESS_LEVEL = Object.freeze({
  BASIC: 1,
  ATTENDEE: 2,
  VERIFIED_ATTENDEE: 3,
  RESEARCH_COORDINATOR: 3.5,
  MEMBER: 4,
  ADMIN: 5,
});

const ROUTE_MINIMUM_ACCESS = Object.freeze({
  "/portal/admin": ACCESS_LEVEL.ADMIN,
  "/portal/common-use-data-sets/admin": ACCESS_LEVEL.ADMIN,
  "/portal/profile": ACCESS_LEVEL.MEMBER,
  "/portal/studies": ACCESS_LEVEL.MEMBER,
  "/portal/my_conferences": ACCESS_LEVEL.VERIFIED_ATTENDEE,
});

export function getAccessLevel(user = {}) {
  if (user.type === "admin" || user.type === "member_admin") {
    return ACCESS_LEVEL.ADMIN;
  }
  if (user.type === "member") return ACCESS_LEVEL.MEMBER;
  if (user.type === "research_coordinator") {
    return ACCESS_LEVEL.RESEARCH_COORDINATOR;
  }
  if (user.type === "attendee" && user.email_verified) {
    return ACCESS_LEVEL.VERIFIED_ATTENDEE;
  }
  if (user.type === "attendee") return ACCESS_LEVEL.ATTENDEE;
  return ACCESS_LEVEL.BASIC;
}

export function isMember(user = {}) {
  return user.type === "member" || user.type === "member_admin";
}

export function canAccessPath(user, pathname) {
  const minimumAccess = ROUTE_MINIMUM_ACCESS[pathname];
  return minimumAccess === undefined || getAccessLevel(user) >= minimumAccess;
}
